<template>
  <div>
    <b-breadcrumb>
      <b-breadcrumb-item :to="`/`">
        <b-icon
          icon="house-fill"
          scale="1.25"
          shift-v="1.25"
          aria-hidden="true"
        ></b-icon>
      </b-breadcrumb-item>
      <b-breadcrumb-item active> View Direct Sales </b-breadcrumb-item>
    </b-breadcrumb>
    <br />
    <b-card title="View Direct Sales Detail">
      <b-col cols="12">
        <b-row class="mb-2">
          <b-col cols="6">
            <b-button size="md" variant="primary" :to="{ name: 'direct-sales' }"
              >Back To Direct Sales</b-button
            >
          </b-col>
        </b-row>
        <b-row>
            <b-col cols="2"><strong>Job Order</strong></b-col>
            <b-col>: {{ form.orderNumber }}</b-col>
        </b-row>
        <b-row>
          <b-col cols="2"><strong>Type</strong></b-col>
          <b-col>: {{ form.props.type }}</b-col>
        </b-row>
        <b-row>
          <b-col cols="2"><strong>Status</strong></b-col>
          <b-col>: {{ form.status }}</b-col>
        </b-row>
        <b-row style="margin-top:10px">
          <b-col cols="12">
            <b-table
              head-variant="dark"
              :fields="fieldsTable"
              :items="form.item"
              small
              responsive
            >
            <template v-slot:cell(quantity)="row">
              <b-input
                :disabled="row.item.pickList.props.statusNo > 35"
                v-model="row.item.pickList.quantity"
                type="number"
              ></b-input>
            </template>
            </b-table>
        </b-col>
    </b-row>
</b-col>
<div class="float-right" v-if="form.status === 'Approved' && form.props.type === 'Direct Sale' && form.item[0].pickList.props.statusNo < 55">
    <b-button
      class="mr-1"
      variant="primary"
      @click ="openModalConfirmCutting = true"
      >Move To Cutting</b-button
    >

    <b-button
      variant="success"
      @click ="toPacking(form.dataItem)"
      >To Packing</b-button
    >
</div>
<div class="float-right" v-else>
    <b-button
      variant="success"
      @click ="jobEnd"
      >Job End</b-button
    >
</div>
</b-card>
<!-- Modal to confirm override quantity -->
  <b-modal
    id="promptView"
    ref="modal"
    size="lg"
    v-model="confirmationModal"
    title="Quantity Confirmation"
    hide-footer
    no-close-on-backdrop
    no-close-on-esc
    hide-close-button
    hide-header-close
  >
    <b-col cols="12">
      <b-row>
        <p>
          The quantity entered is not according to default picklist quantity.
        </p>
        <b-col cols="12" style="margin-bottom: 15px">
          <b-button
            @click="getDataJo()"
            variant="danger"
            class="float-right"
            style="margin-left: 5px"
            >Reset Quantity</b-button
          >
          <b-button
            @click="confirm()"
            variant="success"
            class="float-right"
            style="margin-right: 7px"
            >Confirm and override</b-button
          >
        </b-col>
      </b-row>
    </b-col>
  </b-modal>
  <!-- Modal for showing Packing Details-->
  <b-modal
    id="promptDetail"
    ref="modal"
    size="lg"
    v-model="packingModal"
    title="Packing Process"
    ok-only
    no-close-on-esc
    no-close-on-backdrop
    hide-header-close
  >
    <b-row>
      <b-col cols="3">
        SO Number 
      </b-col>
      <b-col cols="9">
        : {{ formatJoin(this.form.item.map(x => x.pickList.orderNumber)) }}
      </b-col>
      <b-col cols="3">
        PickList Number 
      </b-col>
      <b-col cols="9">
        : {{ this.form.item.map(x => x.pickList.picklistNo + "_" + x.pickList.picklistLine).join(', ') }}
      </b-col>
      <b-col cols="3">
        Timer
      </b-col>
      <b-col cols="9">
        : {{ (this.startTimer==null)?"":totalTimer }}
      </b-col>
      <b-col cols="12" style="margin-top:10px">
        <b-row>
          <b-col cols="6">
              <b-button
              variant="success"
              size="sm"
              block
              class="float-right"
              :disabled="disableStart"
              @click="
                  startPacking()
                "
                >Start Packing</b-button
              >
          </b-col>
            <b-col cols="6">
                <b-button
                variant="danger"
                size="sm"
                block
                class="float-left"
                  :disabled="disableEnd"
                  @click="
                    endPacking()
                  "
                  >End Packing</b-button
                >
            </b-col>
        </b-row>
      </b-col>
    </b-row>
    <template #modal-footer>
      <div class="w-100"></div>
    </template>
  </b-modal>
  <b-modal
    id="promptConfirmCutting"
    ref="modal"
    size="lg"
    v-model="openModalConfirmCutting"
    title="Change Job Type"
  >
    <div class="text-center">
      <h5>Change this type of Joborder to Cutting?</h5>
    </div>
    <template #modal-footer>
      <b-button variant="secondary" @click="openModalConfirmCutting = false">
        Cancel
      </b-button>
      <b-button variant="success" @click="beCutting">
        Confirm
      </b-button>
    </template>
  </b-modal>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import {sleep } from "@/utils/utils.js";
export default {
  props: ["id"],
  data() {
    return {
      form: {
        item: [{
          pickList: {
            quantity: 0,
            props: {
              statusNo: 0,
            },
          }
        }],
        orderNumber: "",
        props: {
          type: ""
        },
        status: ""
      },
      quantity: [],
      updatedQty: [],
      index: 0,
      promptDrum: false,
      title: "",
      fieldsTable: [
        { key: "pickList.fromBatch", label: "Drum Name" },
        { key: "quantity", label: "Quantity" },
        { key: "orderNumber", label: "Pick List" },
      ],
      editingItem: null,
      editingIndex: null,
      initialQuantities: [],
      dataJo:{},
      dataqty:[],
      originalData: {},
      disableStart: false,
      disableEnd: true,
      packingModal: false,
      startTimer:null,
      totalTimer:"",
      modalToLogout: 0,
      confirmationModal: false,

      openModalConfirmCutting: false
    };
  },
  computed: {
  },
  methods: {
    ...mapActions({
      getJobOrder: "joborder/getJobOrder",
    }),
    beCutting() {
      this.$store.dispatch("fetch/addFetchingFromDirectSales", this.$props.id)
      .then((res) => {
        this.$bvToast.toast("Successfully Change to Cutting", {
          title: "Success",
          variant: "success",
          solid: true,
        });
        this.$router.push({ name: "direct-sales" });
      })
      .catch((err) => {
        console.error(err)
        this.$bvToast.toast("Failed Change to Cutting", {
          title: "Failed",
          variant: "danger",
          solid: true,
        });
      })
    },
    async timerRunStart(){
      var currentTime = new Date().getTime();
      var startTime = new Date(this.startTimer).getTime();
      var elapsedTime = currentTime - startTime;

      const hours = Math.floor(elapsedTime / (1000 * 60 * 60));
      const minutes = Math.floor(
        (elapsedTime % (1000 * 60 * 60)) / (1000 * 60)
      );
      const seconds = Math.floor((elapsedTime % (1000 * 60)) / 1000);

      this.totalTimer= `${hours
        .toString()
        .padStart(2, "0")}:${minutes
        .toString()
        .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;

        await sleep(1000)
        if(this.startTimer!=null){
          this.timerRunStart()
        }
    },
    async toPacking(item){
      const currQty = this.form.item.map(el => el.pickList.quantity);
      let thenQty = [];
      await this.$store.dispatch("joborder/getJobOrderId", {
      id: this.$props.id
      }).then(res => {
        thenQty = res.item.map(el => el.pickList.quantity);
      }).catch(err => {
        console.error(err)
        this.$bvToast.toast("Error update data", {
          title: "Error",
          variant: "danger",
          solid: true,
        });
        return
      })

      if (currQty.toString() !== thenQty.toString()) {
        this.updatedQty = currQty;
        this.confirmationModal = true
      }else{
        this.confirm()
      }
    },
    async confirm() {
      await this.$store.dispatch("joborder/processDirectSales", {
        id: this.$props.id,
        payload: {
          qty: this.updatedQty,
          process: 'direct_sales'
        }
      }).then((res) => {
        this.form = res;
        this.packingModal = true
      }).catch(err => {
        console.error(err)
        this.$bvToast.toast("Error update data", {
          title: "Error",
          variant: "danger",
          solid: true,
        });
      })
    },
    async startPacking() {
      this.$store.dispatch('joborder/processDirectSales',{
        id: this.$props.id,
        payload: {
          qty: [],
          process: 'direct_sales_start_packing'
        }
      }).then(res=>{
        this.$bvToast.toast("Successfully start packing", {
          title: "Success",
          variant: "success",
          solid: true,
        });
        this.form = res;
        if (this.form.item[0].pickList.props.flag == 'To Packing') {
          this.packingModal = true
        }
        if (this.form.item[0].pickList.props.PS && !this.form.item[0].pickList.props.PE ) {
          this.startTimer = this.form.item[0].pickList.props.PS
          this.timerRunStart()
          this.disableStart = true
          this.disableEnd = false
          this.packingModal = true
        }
      }).catch(err=>{
        this.$bvToast.toast(err, {
          title: "Error",
          variant: "warning",
          solid: true,
        });
      })
      
      this.disableStart = true
      this.disableEnd = false
    },
    async endPacking() {
      this.$store.dispatch('joborder/processDirectSales',{
        id: this.$props.id,
        payload: {
          qty: [],
          process: 'direct_sales_end_packing' 
        }
      }).then(res=>{
        this.$bvToast.toast("Successfully start packing", {
          title: "Success",
          variant: "success",
          solid: true,
        });
        this.form = res;
        this.disableEnd = true
        this.packingModal = false
        this.startTimer = null
      }).catch(err=>{
        this.$bvToast.toast(err, {
          title: "Error",
          variant: "warning",
          solid: true,
        });
      })
    },
    async jobEnd(){
      this.$store
        .dispatch("joborder/endJobOrder", {
          id: this.$props.id

        })
        .then(() => {
          this.$bvToast.toast("Successfully Finish Direct Sales Job Order", {
            title: "Success",
            variant: "success",
            solid: true,
          });
          this.$router.push({ name: "direct-sales" });
        })
        .catch(err=>{
          this.$bvToast.toast(err, {
            title: "Error",
            variant: "warning",
            solid: true,
          });
        })
    },
    async getDataJo() {
      this.$store.dispatch("joborder/getJobOrderId", {
        id: this.$props.id
      }).then((res)=>{
        this.form = res;
        if (this.form.item[0].pickList.props.flag == 'To Packing') {
          this.packingModal = true
        }
        if (this.form.item[0].pickList.props.PS && !this.form.item[0].pickList.props.PE ) {
          this.startTimer = this.form.item[0].pickList.props.PS
          this.timerRunStart()
          this.disableStart = true
          this.disableEnd = false
          this.packingModal = true
        }

        this.confirmationModal = false
      }).catch(err=>{
        console.error(err)
        this.$bvToast.toast("Error fetching data joborder", {
          title: "Error",
          variant: "danger",
          solid: true,
        });
      })
    },
    formatJoin(data) {
        if (!Array.isArray(data) || data.length === 0) {
          return ''
        }
        // Remove empty strings and undefined, then deduplicate
        const filtered = Array.from(new Set(data.filter(x => x !== '' && x !== undefined && x !== ' ')))
        return filtered.join(', ')
      },
    },
  mounted() {
    this.getDataJo()
  }
};
</script>
